import React from "react";
import { Button } from "@/components/ui/button";
import { Check, MessageCircle } from "lucide-react";
import { waLink } from "@/constants/site";

const BULLETS = [
  "Yüz ovalini belirginleştirmeye yardımcı olur",
  "Gıdı bölgesinde toparlanma sağlar",
  "Çene hattını daha net gösterir",
  "Cilde daha canlı ve sıkı bir görünüm kazandırır",
];

export default function SatenYuzGerme() {
  return (
    <section data-testid="saten-section" className="iona-section bg-[#F8F9FA]">
      <div className="iona-container">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="relative">
              <div className="rounded-[2rem] overflow-hidden iona-soft-shadow">
                <img
                  src="https://images.pexels.com/photos/4945180/pexels-photo-4945180.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=720"
                  alt="Saten Yüz Germe"
                  className="w-full h-[480px] object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 hidden md:block bg-white p-5 rounded-2xl border border-[#F0F0F0] iona-soft-shadow max-w-[200px]">
                <div className="font-serif text-3xl text-[#5E2A84] mb-1">RF</div>
                <div className="text-xs text-[#4A4A4A] leading-snug">
                  Radyo Frekans Teknolojisi
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="text-xs uppercase tracking-[0.3em] text-[#5E2A84] mb-4">
              — Saten Yüz Germe
            </div>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1A1A1A] leading-[1.1] tracking-tight mb-6">
              Ameliyatsız sıkılaşma ve <span className="italic text-[#5E2A84]">genç görünüm</span>
            </h2>
            <p className="text-base text-[#4A4A4A] leading-relaxed mb-8">
              Saten yüz germe uygulaması, cilt altındaki kolajen üretimini
              destekleyerek yüz ovalinin belirginleşmesine, gıdı bölgesinin
              toparlanmasına ve cildin daha sıkı görünmesine yardımcı olur.
            </p>

            <ul className="space-y-3 mb-10">
              {BULLETS.map((b) => (
                <li key={b} className="flex items-start gap-3">
                  <span className="mt-1 w-5 h-5 rounded-full bg-[#5E2A84]/10 text-[#5E2A84] flex items-center justify-center flex-shrink-0">
                    <Check className="w-3 h-3" strokeWidth={3} />
                  </span>
                  <span className="text-[#1A1A1A]">{b}</span>
                </li>
              ))}
            </ul>

            <a
              href={waLink("Merhaba, Saten Yüz Germe uygulaması hakkında bilgi almak istiyorum.")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="saten-cta"
            >
              <Button className="h-13 px-7 py-3 rounded-full bg-[#5E2A84] hover:bg-[#4a2168] text-white iona-soft-shadow">
                <MessageCircle className="w-4 h-4 mr-2" />
                Detaylı Bilgi Al
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
